import React from 'react';
import { useLocation } from 'react-router-dom';
import { Skeleton } from '../../../components/common/SkeletonLoader';
import { ReferClientForm, type ReferPrefill } from '../ReferClientForm';
import { usePartnerPortalContext } from '../portalContext';

const ReferTab: React.FC = () => {
  const { partners, brokers, loading, partnersError, brokersError, createReferral } = usePartnerPortalContext();
  // Another tab (the back book radar) navigates here with { prefill } in router state.
  const prefill = (useLocation().state as { prefill?: ReferPrefill } | null)?.prefill ?? null;

  if (loading) {
    return (
      <div className="rounded-xl border border-gray-700 bg-gray-800/40 p-6 space-y-4">
        <Skeleton height="1.25rem" width="10rem" />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} height="2.5rem" />
          ))}
        </div>
      </div>
    );
  }
  if (brokersError || partnersError) {
    return (
      <div className="rounded-lg border border-red-500/40 bg-red-500/10 px-4 py-3 text-sm text-red-300" role="alert">
        {brokersError
          ? `Could not load the brokers you can refer for. ${brokersError}`
          : `Could not load referral partners. ${partnersError}`}
      </div>
    );
  }
  return <ReferClientForm partners={partners} brokers={brokers} prefill={prefill} onSubmit={createReferral} />;
};

export default ReferTab;
